import React from 'react'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import Button from '../../Components/Button'

function DownloadXlsx(props) {

    const exportToExcel = () => {
        const workbook = XLSX.utils.book_new()
        const worksheet = XLSX.utils.json_to_sheet(props.data)
        XLSX.utils.book_append_sheet(workbook, worksheet, props.isBudget ? "ElecBudgetAnnuel" : "Sheet1")

        props.headRow?.length > 0 && props.headRow.forEach((element) => {
            for (const [key, value] of Object.entries(element)) {
                if (worksheet[key]) worksheet[key].v = value
            }
        })

        if (props.isBudget && props.data2?.length > 0) {
            const worksheet2 = XLSX.utils.json_to_sheet(props.data2)
            XLSX.utils.book_append_sheet(workbook, worksheet2, "ElecBudgetMensuelDetail")

            props.headRow2?.length > 0 && props.headRow2.forEach((element) => {
                for (const [key, value] of Object.entries(element)) {
                    if (worksheet2[key]) worksheet2[key].v = value
                }
            })
        }

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheetcharset=UTF-8' })

        saveAs(blob, props.fileName)
    }

    return (
        <Button
            handleSubmit={exportToExcel}
            cta="Exporter"
            additionnalClassName={`table--tablecontainer__button ${props.additionnalClassName}`} />
    )
}

export default DownloadXlsx;